import React, { useLayoutEffect, useRef } from 'react';

// The same 3D "Orbit" loading scene shown at app launch (index.html's static
// #boot-loading-screen). That one is plain HTML/CSS/JS so it renders before React even mounts, and
// its DOM node gets removed once the app has loaded - so it can't be reused for a later loading
// state like a login/signup submission. This component builds the identical scene with the same
// window.__buildBoot3D helper (defined once in index.html) and the same global .boot3d-* CSS.
const BootSpinner: React.FC<{ className?: string }> = ({ className = '' }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    (window as any).__buildBoot3D?.(rootRef.current);
    // Mount the WebGL logo into the freshly built slot (boot-logo.ts has long since loaded).
    (window as any).__mountBootLogo?.();
  }, []);
  return (
    <div className={`boot-spinner-backdrop fixed inset-0 z-[9999] ${className}`}>
      <div ref={rootRef} className="boot3d-root" role="img" aria-label="RIDAZ is loading" />
    </div>
  );
};

export default BootSpinner;
